module.exports = __webpack_public_path__ + "img/salary.dacd3d7f.svg";